export default __webpack_public_path__ + "static/media/Logo.b4b96d32.png";